import type {Metadata} from '../types';

export const getManifestationCount = (
  expressionId: string,
  metadata: Metadata,
): number => {
  return metadata.manifestations.filter(m => m.expressionId === expressionId)
    .length;
};
